import { useState, useEffect } from 'react';
import { useRoom } from '../../../contexts/RoomContext';
import { BACKEND_URL } from '../../../services/authService';

export default function PlaybackSettings() {
  const { currentRoom, refetchRoom } = useRoom();
  const [pausePlayback, setPausePlayback] = useState(currentRoom?.pausePlayback ?? false);
  const [loading, setLoading] = useState(false);

  console.log('[PlaybackSettings] Component render:', {
    currentRoom_pausePlayback: currentRoom?.pausePlayback,
    local_pausePlayback: pausePlayback,
    currentRoom_full: currentRoom
  });

  useEffect(() => {
    console.log('[PlaybackSettings] useEffect triggered:', {
      currentRoom_pausePlayback: currentRoom?.pausePlayback,
      isDefined: currentRoom?.pausePlayback !== undefined
    });
    if (currentRoom?.pausePlayback !== undefined) {
      setPausePlayback(currentRoom.pausePlayback);
    }
  }, [currentRoom]);

  const handleTogglePlayback = async () => {
    const newValue = !pausePlayback;
    console.log('[PlaybackSettings] Toggle clicked:', {
      oldValue: pausePlayback,
      newValue: newValue,
      url: `${BACKEND_URL}/room/setPausePlayback?pausePlayback=${newValue}`
    });
    setPausePlayback(newValue);
    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/room/setPausePlayback?pausePlayback=${newValue}`, {
        method: 'POST',
        credentials: 'include'
      });
      console.log('[PlaybackSettings] API response status:', response.status, response.ok);
      if (!response.ok) throw new Error('Failed to update playback setting');
      console.log('[PlaybackSettings] Calling refetchRoom...');
      await refetchRoom();
      console.log('[PlaybackSettings] refetchRoom completed');
    } catch (error) {
      console.error('[PlaybackSettings] Failed to update playback settings:', error);
      // Revert the state if the API call failed
      setPausePlayback(!newValue);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-6 pb-6 border-b border-gray-700">
      <h3 className="text-xl font-semibold mb-4">Playback Control</h3>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <label className="text-white block mb-1">Pause Playback</label>
            <p className="text-gray-400 text-sm">
              Prevents songs from playing in this room. Useful for development/testing environments.
            </p>
          </div>
          <button
            onClick={handleTogglePlayback}
            disabled={loading}
            className={`
              relative inline-flex h-6 w-11 items-center rounded-full transition-colors
              ${pausePlayback ? 'bg-red-600' : 'bg-green-600'}
              ${loading ? 'opacity-50 cursor-not-allowed' : ''}
            `}
          >
            <span
              className={`
                inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                ${pausePlayback ? 'translate-x-6' : 'translate-x-1'}
              `}
            />
          </button>
        </div>
        
        {pausePlayback && (
          <div className="bg-red-900/20 border border-red-600/50 rounded p-3">
            <p className="text-red-400 text-sm">
              ⚠️ Playback is currently paused. Songs will not play in this room.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}